angular.module('shared').directive('ngContainer', function () {
    return {
        restrict: 'E',
        controller: function ($element, $scope, $compile) {
            let template = $("#" + $scope.template).html();
            $element.append($compile(template)($scope));
        },
        scope: {
            data: '=',
            template: '='
        }
    };
});